import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

/**
* Типы кнопок
*/
export enum ButtonTypes {
	/**
	 * Основная (обычно синяя)
	 */
	Primary = 1,
	/**
	 * Дополнительная (обычно с синей рамкой)
	 */
	Secondary = 2,
	/**
	 * Обычная (обычно без рамки)
	 */
	Simple = 3
}

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class UIButtonComponent {

  @Input()
  name: string;

  @Input()
  type: ButtonTypes;

  @Input()
  isDisabled: boolean = false;

  @Input()
  icon: string = '';

  class: string;

  classes = {
    [ButtonTypes.Primary]: 'primary',
    [ButtonTypes.Secondary]: 'secondary',
    [ButtonTypes.Simple]: 'simple'
  };

  constructor() { }

  ngOnInit() {
    this.class = this.classes[this.type];
  }
}
